// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ef2c421a","239":"e2199798","453":"4d41caee","455":"600cc692"}[chunkId] + ".chunk.js";
};